type TextFieldIds = {
  helperTextId: string;
  errorTextId: string | undefined;
  charsExceededId: string | undefined;
};

/**
 * Checks if character count exceeds the maximum length
 */
export const isCharsExceeded = (characterCount: number, maxLength: number = 0): boolean =>
  characterCount > maxLength && maxLength > 0;

/**
 * Generates consistent IDs for TextField components
 * @param baseId - The base ID of the TextField component
 * @param hasError - Whether the field has a validation error
 * @param charsExceeded - Whether characters exceed the limit (pre-calculated)
 * @returns Object containing helperTextId, errorTextId, and charsExceededId
 */
export const generateTextFieldIds = (
  baseId: string,
  hasError: boolean = false,
  charsExceeded: boolean = false,
): TextFieldIds => {
  return {
    helperTextId: `${baseId}-Footer-helper-text`,
    errorTextId: hasError ? `${baseId}-Footer-error-text` : undefined,
    charsExceededId: charsExceeded ? `${baseId}-Footer-chars-exceeded` : undefined,
  };
};

export default generateTextFieldIds;
